/**
 * Classe view para a Service Time updates;
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 06/08/2013
 */

App.Views.ServiceTimeUpdates = {

    showPopupInfoSessionExists: function () {

        var error    = null,
            popup    = null,
            selector = "#ServiceTimeUpdates";

        try {

            popup = new Greenmile.ServiceTimeUpdates.PopupSessionAlert(selector);
            popup.showPopup();

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on show popup info session exists.", e);
            error.console();

        }

    },

    showFormSearchResult: function () {

        var error                = null,
            router               = null,
            callbackGenerateForm = null;

        try {

            router = new App.Routers.ServiceTimeUpdates();

            callbackGenerateForm = function () {

                var formSearch = new Greenmile.ServiceTimeUpdates.FormSearch();
                formSearch.show();

            };

            router.getDataUserInterfaceAndGenerateForm('form', callbackGenerateForm, "form");

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on show form search result.", e);
            error.console();

        }

    },

    showGridToServiceTimeUpdates: function (calledByClearGridAndShowAgain) {

        var error                = null,
            router               = null,
            callbackGenerateGrid = null;

        try {

            router = App.Objects.ServiceTimeUpdates;
            var byServiceTimeType = Monet.Session.ServiceTimeUpdates.session.byServiceTimeType;
            var gridType = (!byServiceTimeType ? 'Location': 'ServiceTimeType');
            var entityToLayout = (!byServiceTimeType ? 'ServiceTimeUpdates': 'ServiceTimeUpdatesServiceTimeType');

            callbackGenerateGrid = function () {

                var grid                  = new Greenmile.ServiceTimeUpdates.Grid[gridType](),
                    notValidateEndSession = typeof calledByClearGridAndShowAgain !== "undefined" && calledByClearGridAndShowAgain === true;

                App.Forms.ServiceTimeUpdates.grid = grid;
                grid.show();

                router.getPendingSession(notValidateEndSession);

            };

            router.getDataUserInterfaceAndGenerateForm('index', callbackGenerateGrid, "grid", entityToLayout);

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on show grid to service time updates", e);
            error.console();

        }
    },

    destroyFormAndShowProgressAlert: function () {

        try {

            const formSearch = new Greenmile.ServiceTimeUpdates.FormSearch();
            formSearch.destroy();

            this.showProgressAlert();

        } catch (e) {

            const error = new Monet.Exception.ReturnError(this, "Error on destroy form ans show progress alert.", e);
            error.console();

        }
        
    },

    showProgressAlert: function (progressValue) {

        try {

            const router = new App.Routers.ServiceTimeUpdates();
            const progress = new Greenmile.ServiceTimeUpdates.ProgressSessionAlert('#ServiceTimeUpdates');

            const completeCallback = async () => {
                if (progress.isRendered()) {
                    const session = await router.checkSessionExists();
                    Monet.Session.ServiceTimeUpdates.session = session.sessionInfo;
                    progress.destroy();
                    App.Views.ServiceTimeUpdates.showGridToServiceTimeUpdates();
                }
            };

            const updateCallback = () => {
                if (progress.isRendered()) {
                    setTimeout(() => router.getProgressUpdate(updateCallback, completeCallback), 5000);
                }
            };

            progress.showPopupAndUpdate(progressValue);

            updateCallback();

        } catch (e) {

            const error = new Monet.Exception.ReturnError(this, "Error on destroy form ans show progress alert.", e);
            error.console();

        }

    },

    clearGrid: function () {

        var error       = null,
            formAndGrid = null;

        try {

            formAndGrid = document.querySelector("#ServiceTimeUpdates .grid_list_template");

            if (formAndGrid !== null) {

                var parentNode = formAndGrid.parentNode;

                parentNode.removeChild(formAndGrid);

            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on clear grid.", e);
            error.console();
        }

    },

    clearGridContainerAndShowAgain: function () {

        var error                 = null,
            notValidateEndSession = true;

        try {

            this.clearGrid();

            this.showGridToServiceTimeUpdates(notValidateEndSession);

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on cler grid container and show again", e);
            error.console();

        }

    },

    clearAllFiltersAndUpdateGrid: function () {

        var error       = null,
            fieldSearch = null,
            router      = null;

        try {

            router = App.Objects.ServiceTimeUpdates;

            fieldSearch = document.querySelector("#ServiceTimeUpdates #searchFilter");

            if (fieldSearch !== null && fieldSearch.value !== "") {
                fieldSearch.value = "";
            }

            router.getPendingSession();

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on clear all filter and updateGrid", e);
            error.console();

        }
    },

    askIfUserWantsEndSession: function(keyMessage, yesCallback, noCallback) {
        const div = document.createElement('div');
        const btnYes = document.createElement('input');
        const btnNo = document.createElement('input');
        const message = document.createElement('div');

        btnYes.type = 'button';
        btnNo.type = 'button';

        btnYes.className = 'button yes';
        btnNo.className = 'button no';
        div.className = "infoSessionFinished";
        message.className = "message";


        btnYes.value = Monet.I18n.getResourcesByKey('option.yes');
        btnNo.value = Monet.I18n.getResourcesByKey('option.no');
        message.innerHTML = Monet.I18n.getResourcesByKey(keyMessage);
        div.appendChild(message);
        div.appendChild(btnYes);
        div.appendChild(btnNo);

        btnYes.addEventListener('click', yesCallback);
        btnNo.addEventListener('click', noCallback);

        this.showModalMessage(div, noCallback);
    },

    showSessionClosedOnSuccess: function (keyMessage, onAfterCloseModalForm) {

        const div = document.createElement('div');
        div.setAttribute("class", "infoSessionFinished");
        div.innerHTML = Monet.I18n.getResourcesByKey(keyMessage);

        this.showModalMessage(div, onAfterCloseModalForm);

    },

    showModalMessage: function(childElement, onAfterCloseModalForm) {
        var error = null;

        try {

            var selector   = "#ServiceTimeUpdates",
                scopeBlock = "#ServiceTimeUpdates #form_and_grid",
                options    = {
                    width: 400,
                    height: 250
                },
                callbacks  = {
                    onAfterShowModalForm: function () {

                        const container = document.querySelector("#ServiceTimeUpdates .popupFormContainer");

                        if (container !== null) {
                            container.appendChild(childElement);

                        }

                    },
                    onAfterCloseModalForm
                };

            var modal = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);

            modal.showModalForm();

            this.modal = modal;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on show session closed on sucess", e);
            error.console();

        }
    },

    setGridOrderDefault: function (fieldName) {

        var error         = null,
            column        = null,
            grid          = null,
            fieldId = 0;

        try {

            grid = App.Forms.ServiceTimeUpdates.table;

            column = grid.getColumnByFieldName(fieldName);

            fieldId = column.id;

            grid.setSortColumn(fieldId, "ASC");

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on set grid order default.", e);
            error.console();

        }

    }
};
